import React from 'react';
import {Checkbox, FormGroup} from 'react-bootstrap';
import {IS_CALENDAR_VISIBLE} from '../constants';

const RegistrationCalendarToggle = ({isCalendarVisible = true, onUpdate}) => {
    return (
        <FormGroup>
            <Checkbox
                checked={isCalendarVisible}
                value={isCalendarVisible}
                name={IS_CALENDAR_VISIBLE}
                onChange={(e) => onUpdate(IS_CALENDAR_VISIBLE, e.target.checked)}
            >
                Показывать кнопку Добавить в календарь
            </Checkbox>
        </FormGroup>
    )
}

export default RegistrationCalendarToggle;
